<template>
  <div class="d-flex align-center w-full pl-8">
    <div style="width: 210px" class="d-flex align-center">
      <SysGrupoAutocomplete
        v-model="grupo_compra"
        label="Grupo de compras"
        hide-details
        outlined
        dense
        :disabled="data_table_departamentos_carregando_dados"
        style="width: 210px"
        append-icon="mdi-chevron-down"
      />
<!--      :unshift-items="{id: 0, descricao: 'Todos'}"-->
    </div>

<!--    <div style="width: 210px" class="d-flex align-center ml-4">-->
<!--      <SysFilialGrupoAutocomplete-->
<!--        v-model="filial_compra"-->
<!--        :id-grupo="grupo_compra"-->
<!--        label="Filial"-->
<!--        hide-details-->
<!--        outlined-->
<!--        dense-->
<!--        :disabled="data_table_departamentos_carregando_dados"-->
<!--        style="width: 210px"-->
<!--        append-icon="mdi-chevron-down"-->
<!--        :unshift-items="{id: 9999, descricao: grupo_compra > 0 ? 'Todas' : 'Multiplos grupos'}"-->
<!--      />-->
<!--    </div>-->

    <MudarDeDepartamentoDialog />

    <v-spacer />

    <CarrinhoCompra />
  </div>
</template>

<script>
import SysGrupoAutocomplete from "../../utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "../../utils/crud/SysFilialGrupoAutocomplete";
import CarrinhoCompra from "./carrinho/Index.vue";
import MudarDeDepartamentoDialog from "./MudarDeDepartamentoDialog";
import VisibilidadeCarrinhoCompraComputed from "./carrinho/VisibilidadeCarrinhoCompraComputed";
import {parametros_rota} from "./helpers/ParametrosRota.js";
import {data_table_departamentos_carregando_dados} from "../../utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js";
import Configuracao from "./Configuracao.vue";

export default {
  name: "BarraDeMenuPrincipal",
  mixins: [parametros_rota, VisibilidadeCarrinhoCompraComputed, data_table_departamentos_carregando_dados],
  components: {
    MudarDeDepartamentoDialog,
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    CarrinhoCompra,
    Configuracao
  }
}
</script>

<style scoped>
</style>
